export default {"src":"/_next/static/media/icon-location-career.c4bdb0e4.svg","height":15,"width":11,"blurWidth":0,"blurHeight":0};